export default {
    mounted () {
        let self = this;
        Bus.$on("inspection-created", function () {
            self.hideInspectionCreateForm();
        });
    },

    methods: {
        showInspectionCreateForm () {
            if (this.verifyTeamIsSubscribed()) {
                $("#modal-inspection-form").modal("show");
            }
        },

        hideInspectionCreateForm () {
            $("#modal-inspection-form").modal("hide");
        },
    },
};
